import { render, staticRenderFns } from "./EditarTipoMedidaModal.vue?vue&type=template&id=b67038e2&"
import script from "./EditarTipoMedidaModal.vue?vue&type=script&lang=ts&"
export * from "./EditarTipoMedidaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b67038e2', component.options)
    } else {
      api.reload('b67038e2', component.options)
    }
    module.hot.accept("./EditarTipoMedidaModal.vue?vue&type=template&id=b67038e2&", function () {
      api.rerender('b67038e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoMedida/EditarTipoMedidaModal.vue"
export default component.exports